import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import './tour.css'

export function runTour({ steps, t, onFinish }) {
  const d = driver({
    steps,
    showProgress: true,
    progressText: '{{current}} / {{total}}',
    allowClose: true,
    allowKeyboardControl: false,
    disableActiveInteraction: true,
    overlayOpacity: 0.78,
    stagePadding: 6,
    stageRadius: 12,
    popoverClass: 'calypso-tour',
    nextBtnText: t('tour_siguiente'),
    prevBtnText: t('tour_anterior'),
    doneBtnText: t('tour_listo'),
    // Recalcula la posición cuando la página ya terminó de acomodarse
    onHighlighted: (el, step, { driver }) => {
      setTimeout(() => driver.refresh(), 350)
    },
    onDestroyed: () => {
      // Si cierran el tour a la mitad, no dejamos paneles abiertos
      window.dispatchEvent(new CustomEvent('calypso:plantillas', { detail: 'close' }))
      onFinish?.()
    }
  })
  d.drive()
  return d
}